var render = function render(_c,_vm){return _c('section',{staticClass:"ulsemo-logo"},[_c('img',{attrs:{"src":_vm.props.img_src,"alt":"ulsemo icon"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }